import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { handleErrorMessage } from 'src/app/helpers/error-handler.helper';
import { ErrorMessageService } from 'src/app/services/error-message/error-message.service';
import { FinalLoanApplication } from 'src/app/services/loan/loan.model';
import { LoanService } from 'src/app/services/loan/loan.service';
import {
  PHONE_VALID_REGEX,
  stripPhoneNumber,
} from 'src/app/directives/phone-number/phone-number.directive';

@Component({
  selector: 'app-modal-finish-by-phone',
  templateUrl: './modal-finish-by-phone.component.html',
  styleUrls: ['./modal-finish-by-phone.component.scss'],
})
export class ModalFinishByPhoneComponent implements OnInit {
  @Input() loan: FinalLoanApplication | null = null;

  phone = '';
  isSaving = false;
  isPhoneValid = true;

  constructor(
    public activeModal: NgbActiveModal,
    private loanService: LoanService,
    private errorMessageService: ErrorMessageService
  ) {}

  ngOnInit(): void {}

  validate(phone: string) {
    const valid = PHONE_VALID_REGEX.test(phone);

    return valid;
  }

  async onConfirm() {
    if (!this.phone || !this.validate(this.phone)) {
      return;
    }

    await this.saveLoanApplication();
  }

  onCancel() {
    this.activeModal.close();
  }

  onPhoneChange(event: any) {
    const phone = event.target.value;

    this.isPhoneValid = true;

    if (phone) {
      this.isPhoneValid = this.validate(phone);
    }
  }

  private async saveLoanApplication(): Promise<void> {
    try {
      this.isSaving = true;

      const response = await this.loanService.postLoanApplication(
        {
          ...this.loan,
          Applicant: {
            ...this.loan?.Applicant,
            PhoneNumber: stripPhoneNumber(this.phone),
          },
        },
        'loan/skip'
      );

      if (response) {
        this.loanService.setLoanAfterPost(response);

        // The promise that is resolved when the modal is closed and rejected when the modal is dismissed.
        this.activeModal.close({
          status: 'confirmed',
        });
      }

      return;
    } catch (error) {
      this.errorMessageService.addToErrorMessages(handleErrorMessage(error));
      this.activeModal.close();
    } finally {
      this.isSaving = false;
    }
  }
}
